export const SET_LANG = 'SET_LANG';

export const setLangAction = (lang: string) => ({
  type: SET_LANG,
  lang
});